module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-assigned-by-me.8b4dea8f.svg";